const data = [
  {
    title: "Quiz One",
    rounds: [
      {
        name: "Sport",
        questions: [
          {
            number: "1",
            text: "Roughly, how many golf courses does Scotland have?",
            answers: [
              {
                letter: "A:",
                text: "152"
              },
              {
                letter: "B:",
                text: "236"
              },
              {
                letter: "C:",
                text: "560"
              },
              {
                letter: "D:",
                text: "809"
              },
            ],
            correctAnswer: "C: 560",
            video: require("./exercise-videos/sport-chariots/sport-chariots.mp4"),
            subtitles: require("./exercise-videos/sport-chariots/sport-chariots.vtt"),
            extraInfo: "Figures for registered golf courses as of 2018."
          },
          {
            number: "2",
            text: "What colours make up the Olympic rings?",
            answers: [
              {
                letter: "A:",
                text: "Blue, Orange, Red, Green and Yellow"
              },
              {
                letter: "B:",
                text: "Blue, Black, Red, Yellow and Green"
              },
              {
                letter: "C:",
                text: "Blue, Red, Green and Yellow"
              },
              {
                letter: "D:",
                text: "Blue, Red, White, Yellow and Black"
              },
            ],
            correctAnswer: "B: Blue, Black, Red, Yellow and Green",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: ""
          },
          {
            number: "3",
            text: "Which player holds the record for most caps/appearances for Scotland?",
            answers: [
              {
                letter: "A:",
                text: "Darren Fletcher"
              },
              {
                letter: "B:",
                text: "Denis Law"
              },
              {
                letter: "C:",
                text: "Jim Leighton"
              },
              {
                letter: "D:",
                text: "Kenny Dalglish"
              },
            ],
            correctAnswer: "D: Kenny Dalglish",
            video: require("./exercise-videos/sport-ski/sport-ski.mp4"),
            subtitles: require("./exercise-videos/sport-ski/sport-ski.vtt"),
            extraInfo: "With 102 appearances and 30 goals between 1971 and 1986, Dalglish is the most capped and joint-leading goal-scorer (with Denis Law)."
          },
          {
            number: "4",
            text: "In 1973, Mike Denness became the first Scotsman to captain England in which sport?",
            answers: [
              {
                letter: "A:",
                text: "Cricket"
              },
              {
                letter: "B:",
                text: "Football"
              },
              {
                letter: "C:",
                text: "Ice Hockey"
              },
              {
                letter: "D:",
                text: "Rugby"
              },
            ],
            correctAnswer: "A: Cricket",
            video: require("./exercise-videos/sport-weightlifter/sport-weightlifter.mp4"),
            subtitles: require("./exercise-videos/sport-weightlifter/sport-weightlifter.vtt"),
            extraInfo: "Scotland did not have a representative international team at the time Denness he could only play for England at Test and ’One Day International’ level."
          },
          {
            number: "5",
            text: "In which sport might an athlete perform a flip, a flying camel, a Lutz, or an axel?",
            answers: [
              {
                letter: "A:",
                text: "Figure skating"
              },
              {
                letter: "B:",
                text: "Gymnastics"
              },
              {
                letter: "C:",
                text: "Diving"
              },
              {
                letter: "D:",
                text: "Skiing"
              },
            ],
            correctAnswer: "A: Figure skating",
            video: require("./exercise-videos/sport-weightlifter/sport-weightlifter.mp4"),
            subtitles: require("./exercise-videos/sport-weightlifter/sport-weightlifter.vtt"),
            extraInfo: "In figure skating ice skaters, singly or in pairs, perform freestyle movements of jumps, spins, lifts, and footwork in a graceful manner."
          }
        ]
      },
      {
        name: "Entertainment",
        questions: [
          {
            number: "1",
            text: "Who first sang: \"Get your motor running, head out on the highway\"?",
            answers: [
              {
                letter: "A:",
                text: "ACDC"
              },
              {
                letter: "B:",
                text: "Steppenwolf"
              },
              {
                letter: "C:",
                text: "Led Zeppelin"
              },
              {
                letter: "D:",
                text: "Cream"
              },
            ],
            correctAnswer: "B: Steppenwolf",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "First recorded in 1968 and later used in the film Easy Rider starring Dennis Hopper and Peter Fonda."
          },
          {
            number: "2",
            text: "Who first sang: \"Your beauty is beyond compare, with flaming locks of auburn hair\"?",
            answers: [
              {
                letter: "A:",
                text: "Dolly Parton"
              },
              {
                letter: "B:",
                text: "Olivia Newton-John"
              },
              {
                letter: "C:",
                text: "Simon and Garfunkel"
              },
              {
                letter: "D:",
                text: "Bob Dylan"
              },
            ],
            correctAnswer: "A: Dolly Parton",
            video: require("./exercise-videos/entertain-applause/entertain-applause.mp4"),
            subtitles: require("./exercise-videos/entertain-applause/entertain-applause.vtt"),
            extraInfo: "In the 1973 song Jolene. According to Parton the song was inspired by a red-headed bank clerk who flirted with her husband."
          },
          {
            number: "3",
            text: "What were Frank Sinatra's legion of young female fans called?",
            answers: [
              {
                letter: "A:",
                text: "Bobby Soxers"
              },
              {
                letter: "B:",
                text: "Bobby dazzlers"
              },
              {
                letter: "C:",
                text: "Deely Boppers"
              },
              {
                letter: "D:",
                text: "Jitterbuggers"
              },
            ],
            correctAnswer: "A: Bobby Soxers",
            video: require("./exercise-videos/entertain-applause/entertain-applause.mp4"),
            subtitles: require("./exercise-videos/entertain-applause/entertain-applause.vtt"),
            extraInfo: "Usually teenage girls in high schools and colleges, who got their name from the bobby socks that they wore."
          },
          {
            number: "4",
            text: "In 2017 which English novelist first appeared on the back of the new polymer £10 notes?",
            answers: [
              {
                letter: "A:",
                text: "Charles Dickens"
              },
              {
                letter: "B:",
                text: "George Orwell"
              },
              {
                letter: "C:",
                text: "J.K. Rowling"
              },
              {
                letter: "D:",
                text: "Jane Austen"
              },
            ],
            correctAnswer: "D: Jane Austen",
            video: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4"),
            subtitles: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.vtt"),
            extraInfo: "Austen (1775 - 1817) is famous for books including Pride and Prejudice, Sense and Sensibility, and Emma. Queen Elizabeth II is on the other side of the note."
          },
          {
            number: "5",
            text: "Which pop duo was the first western band to play in China?",
            answers: [
              {
                letter: "A:",
                text: "Hall & Oats"
              },
              {
                letter: "B:",
                text: "Pet Shop Boys"
              },
              {
                letter: "C:",
                text: "Wham!"
              },
              {
                letter: "D:",
                text: "Tears for Fears"
              },
            ],
            correctAnswer: "C: Wham!",
            video: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.mp4"),
            subtitles: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.vtt"),
            extraInfo: "Wham! Consisting of George Michael and Andrew Ridgeley, spent 10 days in China during the 1985 world tour."
          }
        ]
      },
      {
        name: "Round the world",
        questions: [
          {
            number: "1",
            text: "What percentage of the earth's surface is covered by Europe?",
            answers: [
              {
                letter: "A:",
                text: "2%"
              },
              {
                letter: "B:",
                text: "7%"
              },
              {
                letter: "C:",
                text: "12%"
              },
              {
                letter: "D:",
                text: "20%"
              },
            ],
            correctAnswer: "A: 2%",
            video: require("./exercise-videos/world-everest/world-everest.mp4"),
            subtitles: require("./exercise-videos/world-everest/world-everest.vtt"),
            extraInfo: "At around 3,930,000 square miles. It covers 6.8% of land area."
          },
          {
            number: "2",
            text: "On which continent are the Atlas Mountains?",
            answers: [
              {
                letter: "A:",
                text: "Asia"
              },
              {
                letter: "B:",
                text: "Africa"
              },
              {
                letter: "C:",
                text: "Europe"
              },
              {
                letter: "D:",
                text: "South America"
              },
            ],
            correctAnswer: "B: Africa",
            video: require("./exercise-videos/world-barn-dance/world-barn-dance.mp4"),
            subtitles: require("./exercise-videos/world-barn-dance/world-barn-dance.vtt"),
            extraInfo: "This 2,500km range in North Africa divides the Mediterranean and Atlantic coastline from the Sahara Desert."
          },
          {
            number: "3",
            text: "In which city would you find the Uffizi art gallery?",
            answers: [
              {
                letter: "A:",
                text: "Barcelona"
              },
              {
                letter: "B:",
                text: "Rome"
              },
              {
                letter: "C:",
                text: "Paris"
              },
              {
                letter: "D:",
                text: "Florence"
              },
            ],
            correctAnswer: "D: Florence",
            video: require("./exercise-videos/world-can-can/world-can-can.mp4"),
            subtitles: require("./exercise-videos/world-can-can/world-can-can.vtt"),
            extraInfo: "The gallery holds a collection of priceless works, particularly from the period of the Italian Renaissance."
          },
          {
            number: "4",
            text: "What is the world's fastest animal?",
            answers: [
              {
                letter: "A:",
                text: "Black Marlin"
              },
              {
                letter: "B:",
                text: "Cheetah"
              },
              {
                letter: "C:",
                text: "Peregrine Falcon"
              },
              {
                letter: "D:",
                text: "Antelope"
              },
            ],
            correctAnswer: "C: Peregrine Falcon",
            video: require("./exercise-videos/world-thai-chi/world-thai-chi.mp4"),
            subtitles: require("./exercise-videos/world-thai-chi/world-thai-chi.vtt"),
            extraInfo: "Reaching 200 mph. The Cheetah is the fastest land animal reaching speeds up to 75 mph."
          },
          {
            number: "5",
            text: "Safari is the Swahili word for what?",
            answers: [
              {
                letter: "A:",
                text: "Animals"
              },
              {
                letter: "B:",
                text: "Drive"
              },
              {
                letter: "C:",
                text: "Hunt"
              },
              {
                letter: "D:",
                text: "Journey"
              },
            ],
            correctAnswer: "D: Journey",
            video: require("./exercise-videos/world-can-can/world-can-can.mp4"),
            subtitles: require("./exercise-videos/world-can-can/world-can-can.vtt"),
            extraInfo: "Originally from the Arabic word ‘safar’ meaning a journey, travelling, touring or voyaging."
          }
        ]
      },
      {
        name: "History",
        questions: [
          {
            number: "1",
            text: "In which year did the USA enter World War II?",
            answers: [
              {
                letter: "A:",
                text: "1941"
              },
              {
                letter: "B:",
                text: "1942"
              },
              {
                letter: "C:",
                text: "1943"
              },
              {
                letter: "D:",
                text: "1944"
              },
            ],
            correctAnswer: "A: 1941",
            video: require("./exercise-videos/history-cold-war/history-cold-war.mp4"),
            subtitles: require("./exercise-videos/history-cold-war/history-cold-war.vtt"),
            extraInfo: "On 8 December the US Congress declared war on Empire of Japan in response to that country's surprise attack on Pearl Harbour the previous day."
          },
          {
            number: "2",
            text: "What nationality was revolutionary hero Ernesto 'Che' Guevara?",
            answers: [
              {
                letter: "A:",
                text: "Mexican"
              },
              {
                letter: "B:",
                text: "Cuban"
              },
              {
                letter: "C:",
                text: "Argentinian"
              },
              {
                letter: "D:",
                text: "Bolivian"
              },
            ],
            correctAnswer: "C: Argentinian",
            video: require("./exercise-videos/history-bagpipe/history-bagpipe.mp4"),
            subtitles: require("./exercise-videos/history-bagpipe/history-bagpipe.vtt"),
            extraInfo: "A Marxist revolutionary, physician and a key figure in the Cuban Revolution. He was killed in 1967 by the Bolivian army age 39."
          },
          {
            number: "3",
            text: "Which ship did Lieutenant James Cook command on his first voyage of discovery, to Australia and New Zealand?",
            answers: [
              {
                letter: "A:",
                text: "Endeavour"
              },
              {
                letter: "B:",
                text: "Endurance"
              },
              {
                letter: "C:",
                text: "Discovery"
              },
              {
                letter: "D:",
                text: "Bounty"
              },
            ],
            correctAnswer: "A: Endeavour",
            video: require("./exercise-videos/history-cold-war/history-cold-war.mp4"),
            subtitles: require("./exercise-videos/history-cold-war/history-cold-war.vtt"),
            extraInfo: "British explorer Cook (1728–1779) discovered New Zealand for Europe and widely surveyed and mapped features of the Pacific Ocean coastline."
          },
          {
            number: "4",
            text: "The civil war of which country lasted from 1936-1939?",
            answers: [
              {
                letter: "A:",
                text: "Mexico"
              },
              {
                letter: "B:",
                text: "Korea"
              },
              {
                letter: "C:",
                text: "Haiti"
              },
              {
                letter: "D:",
                text: "Spain"
              },
            ],
            correctAnswer: "D: Spain",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "Fought by groups loyal to the leftist government against right-wing groups the war ushered in the rule of General Franco."
          },
          {
            number: "5",
            text: "What were Benjy and Laska, which were sent into space in 1958?",
            answers: [
              {
                letter: "A:",
                text: "Dogs"
              },
              {
                letter: "B:",
                text: "Mice"
              },
              {
                letter: "C:",
                text: "Monkeys"
              },
              {
                letter: "D:",
                text: "Radios"
              },
            ],
            correctAnswer: "B: Mice",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "Sent by the U.S.A. The first animal in space was a Moscow street dog named Laika, launched by the Soviets in 1957."
          }
        ]
      }
    ],
    tiebreakerQuestion: "Scotland's Forth Road Bridge near Edinburgh officially opened when?",
    tiebreakerAnswer: "1964"
  },
  {
    title: "Quiz Two",
    rounds: [
      {
        name: "Sport",
        questions: [
          {
            number: "1",
            text: "Which British female tennis player partnered Andy Murray to silver at the 2012 Olympic Games?",
            answers: [
              {
                letter: "A:",
                text: "Johanna Konta"
              },
              {
                letter: "B:",
                text: "Samantha Murray"
              },
              {
                letter: "C:",
                text: "Serena Williams"
              },
              {
                letter: "D:",
                text: "Laura Robson"
              },
            ],
            correctAnswer: "D: Laura Robson",
            video: require("./exercise-videos/sport-ski/sport-ski.mp4"),
            subtitles: require("./exercise-videos/sport-ski/sport-ski.vtt"),
            extraInfo: "They lost to Max Mirnyi and Victoria Azarenka of Belarus in the Olympic final of the mixed tennis doubles: 2-6, 6-3, 10-8."
          },
          {
            number: "2",
            text: "Which was the first Scottish football club to reach the UEFA Cup Final?",
            answers: [
              {
                letter: "A:",
                text: "Celtic"
              },
              {
                letter: "B:",
                text: "Rangers"
              },
              {
                letter: "C:",
                text: "Dundee United"
              },
              {
                letter: "D:",
                text: "Aberdeen"
              },
            ],
            correctAnswer: "C: Dundee United",
            video: require("./exercise-videos/sport-chariots/sport-chariots.mp4"),
            subtitles: require("./exercise-videos/sport-chariots/sport-chariots.vtt"),
            extraInfo: "In 1987, losing to IFK Göteborg.  At the time English clubs were banned as a result of fatal rioting at the Heysel Stadium."
          },
          {
            number: "3",
            text: "In the 1990s which Scottish snooker player won the World Championship 7 times?",
            answers: [
              {
                letter: "A:",
                text: "Stephen Hendry"
              },
              {
                letter: "B:",
                text: "Stephen Maguire"
              },
              {
                letter: "C:",
                text: "John Higgins"
              },
              {
                letter: "D:",
                text: "Neil Robertson"
              },
            ],
            correctAnswer: "A: Stephen Hendry",
            video: require("./exercise-videos/sport-weightlifter/sport-weightlifter.mp4"),
            subtitles: require("./exercise-videos/sport-weightlifter/sport-weightlifter.vtt"),
            extraInfo: "Hendry’s first world title was in 1990 at the age of 21, making him the youngest ever world champion."
          },
          {
            number: "4",
            text: "Who scored the first goal in the English Premier League?",
            answers: [
              {
                letter: "A:",
                text: "Teddy Sheringham"
              },
              {
                letter: "B:",
                text: "Brian Deane"
              },
              {
                letter: "C:",
                text: "Alan Shearer"
              },
              {
                letter: "D:",
                text: "Neil Robertson"
              },
            ],
            correctAnswer: "B: Brian Deane",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "For Sheffield United playing Manchester United. Alan Shearer is top scorer with 260 goals."
          },
          {
            number: "5",
            text: "In the Tour De France, what is the 'Lanterne Rouge'?",
            answers: [
              {
                letter: "A:",
                text: "The final stage of the race"
              },
              {
                letter: "B:",
                text: "Rider in last place"
              },
              {
                letter: "C:",
                text: "The highest point in the route"
              },
              {
                letter: "D:",
                text: "The medical assistance team"
              },
            ],
            correctAnswer: "B: Rider in last place",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "Originally the red lantern hung on the rear of a train."
          }
        ]
      },
      {
        name: "Entertainment",
        questions: [
          {
            number: "1",
            text: "Pop star Madonna's eldest child shares her name with which Catholic shrine?",
            answers: [
              {
                letter: "A:",
                text: "Lourdes"
              },
              {
                letter: "B:",
                text: "Fatima"
              },
              {
                letter: "C:",
                text: "Guadalupe"
              },
              {
                letter: "D:",
                text: "Carmel"
              },
            ],
            correctAnswer: "A: Lourdes",
            video: require("./exercise-videos/entertain-applause/entertain-applause.mp4"),
            subtitles: require("./exercise-videos/entertain-applause/entertain-applause.vtt"),
            extraInfo: "Madonna’s other children are Rocco, David, Mercy, Estere and Stella."
          },
          {
            number: "2",
            text: "John Lennon wrote the song \"Julia\" about whom?",
            answers: [
              {
                letter: "A:",
                text: "His sister"
              },
              {
                letter: "B:",
                text: "His mother"
              },
              {
                letter: "C:",
                text: "An ex-lover"
              },
              {
                letter: "D:",
                text: "Yoko’s daughter"
              },
            ],
            correctAnswer: "B: His mother",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "Performed solo by Lennon on the Beatles 1968 ‘White Album’. Julia died in 1958 age 44."
          },
          {
            number: "3",
            text: "Which of the following rock and roll stars did NOT die in a plane crash 3rd Feb 1959?",
            answers: [
              {
                letter: "A:",
                text: "Richie Valens"
              },
              {
                letter: "B:",
                text: "J.P. ‘The Big Bopper’ Richardson"
              },
              {
                letter: "C:",
                text: "Buddy Holly"
              },
              {
                letter: "D:",
                text: "Jerry Lee Lewis"
              },
            ],
            correctAnswer: "D: Jerry Lee Lewis",
            video: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4"),
            subtitles: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.vtt"),
            extraInfo: "Inspiring Don McLean’s 1971 song American Pie."
          },
          {
            number: "4",
            text: "On the Abbey Road album cover which Beatle is crossing the road barefoot?",
            answers: [
              {
                letter: "A:",
                text: "George"
              },
              {
                letter: "B:",
                text: "John"
              },
              {
                letter: "C:",
                text: "Ringo"
              },
              {
                letter: "D:",
                text: "Paul"
              },
            ],
            correctAnswer: "D: Paul",
            video: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4"),
            subtitles: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.vtt"),
            extraInfo: "The Beatle’s eleventh studio album released in 1969 and named after the location of EMI Studios in London. On the cover the group is walking across the street's zebra crossing."
          },
          {
            number: "5",
            text: "Which singer once bit the head off a bat?",
            answers: [
              {
                letter: "A:",
                text: "Shane Macgowan"
              },
              {
                letter: "B:",
                text: "Lemmy"
              },
              {
                letter: "C:",
                text: "Ozzy Osbourne"
              },
              {
                letter: "D:",
                text: "Liam Gallacher"
              },
            ],
            correctAnswer: "C: Ozzy Osbourne",
            video: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.mp4"),
            subtitles: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.vtt"),
            extraInfo: "The dead bat was thrown on stage by a fan at show in 1982. The star had thought it was rubber."
          }
        ]
      },
      {
        name: "Round the world",
        questions: [
          {
            number: "1",
            text: "What is the longest river in the world?",
            answers: [
              {
                letter: "A:",
                text: "Congo"
              },
              {
                letter: "B:",
                text: "Mississippi"
              },
              {
                letter: "C:",
                text: "Amazon"
              },
              {
                letter: "D:",
                text: "Nile"
              },
            ],
            correctAnswer: "D: Nile",
            video: require("./exercise-videos/world-can-can/world-can-can.mp4"),
            subtitles: require("./exercise-videos/world-can-can/world-can-can.vtt"),
            extraInfo: "The Nile – 4132 miles, The Amazon – 3976 miles, The Mississippi – 3902 miles, The Congo – 2922 miles"
          },
          {
            number: "2",
            text: "Dundee has traditionally been famous for its three Js - Jam, Jute and what?",
            answers: [
              {
                letter: "A:",
                text: "Joinery"
              },
              {
                letter: "B:",
                text: "Judges"
              },
              {
                letter: "C:",
                text: "Journalism"
              },
              {
                letter: "D:",
                text: "Jokes"
              },
            ],
            correctAnswer: "C: Journalism",
            video: require("./exercise-videos/world-thai-chi/world-thai-chi.mp4"),
            subtitles: require("./exercise-videos/world-thai-chi/world-thai-chi.vtt"),
            extraInfo: "DC Thomson, publishers of The Beano, The Dandy, The Sunday Post and the People’s Friend, was established in 1905."
          },
          {
            number: "3",
            text: "Which of these countries is not crossed by the equator?",
            answers: [
              {
                letter: "A:",
                text: "India"
              },
              {
                letter: "B:",
                text: "Kenya"
              },
              {
                letter: "C:",
                text: "Brazil"
              },
              {
                letter: "D:",
                text: "The Maldives"
              },
            ],
            correctAnswer: "A: India",
            video: require("./exercise-videos/world-everest/world-everest.mp4"),
            subtitles: require("./exercise-videos/world-everest/world-everest.vtt"),
            extraInfo: "India is situated North of the Equator."
          },
          {
            number: "4",
            text: "Which country do swallows migrate to when they leave Britain for the winter?",
            answers: [
              {
                letter: "A:",
                text: "South Africa"
              },
              {
                letter: "B:",
                text: "Thailand"
              },
              {
                letter: "C:",
                text: "Ethiopia"
              },
              {
                letter: "D:",
                text: "Yemen"
              },
            ],
            correctAnswer: "A: South Africa",
            video: require("./exercise-videos/world-everest/world-everest.mp4"),
            subtitles: require("./exercise-videos/world-everest/world-everest.vtt"),
            extraInfo: "In the UK each April to September, swallows then spend about six weeks on their return to South Africa and Namibia."
          },
          {
            number: "5",
            text: "Fugu, the Japanese word for the poisonous puffer fish, translates as.",
            answers: [
              {
                letter: "A:",
                text: "Water tiger"
              },
              {
                letter: "B:",
                text: "River pig"
              },
              {
                letter: "C:",
                text: "Mud monster"
              },
              {
                letter: "D:",
                text: "Chicken of the sea"
              },
            ],
            correctAnswer: "B: River pig",
            video: require("./exercise-videos/world-barn-dance/world-barn-dance.mp4"),
            subtitles: require("./exercise-videos/world-barn-dance/world-barn-dance.vtt"),
            extraInfo: "A delicacy in Japan but also lethally poisonous, by law only rigorously trained chefs are allowed to prepare the fish."
          }
        ]
      },
      {
        name: "History",
        questions: [
          {
            number: "1",
            text: "In 1885 the Congo was established as the personal possession of the king of?",
            answers: [
              {
                letter: "A:",
                text: "Belgium"
              },
              {
                letter: "B:",
                text: "Portugal"
              },
              {
                letter: "C:",
                text: "Italy"
              },
              {
                letter: "D:",
                text: "Austria Hungary"
              },
            ],
            correctAnswer: "A: Belgium",
            video: require("./exercise-videos/history-cold-war/history-cold-war.mp4"),
            subtitles: require("./exercise-videos/history-cold-war/history-cold-war.vtt"),
            extraInfo: "Leopold II annexed Congo for Belgium and is held responsible for widespread atrocities against the population."
          },
          {
            number: "2",
            text: "The majority of immigrants to the USA between 1820 and 1920 came from?",
            answers: [
              {
                letter: "A:",
                text: "Germany"
              },
              {
                letter: "B:",
                text: "Ireland"
              },
              {
                letter: "C:",
                text: "Mexico"
              },
              {
                letter: "D:",
                text: "Italy"
              },
            ],
            correctAnswer: "A: Germany",
            video: require("./exercise-videos/history-cold-war/history-cold-war.mp4"),
            subtitles: require("./exercise-videos/history-cold-war/history-cold-war.vtt"),
            extraInfo: "Over 5,500,000 from the area that later became Germany. From Ireland 4,400,000 and Italy 4,190,000. Census data suggests immigration from Mexico was much lower."
          },
          {
            number: "3",
            text: "Which kind of animal did Florence Nightingale rescue and often carry in her pocket?",
            answers: [
              {
                letter: "A:",
                text: "Mouse"
              },
              {
                letter: "B:",
                text: "Puppy"
              },
              {
                letter: "C:",
                text: "Kitten"
              },
              {
                letter: "D:",
                text: "Owl"
              },
            ],
            correctAnswer: "D: Owl",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "The baby owl was rescued by Nightingale, founder of modern nursing (1820-1910) after it took a fall from it’s nest at the Parthenon in Athens, Greece."
          },
          {
            number: "4",
            text: "What was the American codename for development of the atom bomb?",
            answers: [
              {
                letter: "A:",
                text: "Project Washington"
              },
              {
                letter: "B:",
                text: "The Manhattan Project"
              },
              {
                letter: "C:",
                text: "Operation Alamo"
              },
              {
                letter: "D:",
                text: "Operation Crossbow"
              },
            ],
            correctAnswer: "B: The Manhattan Project",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "Led by physicist J. Robert Oppenheimer. A first successful test took place on 16 July 1945."
          },
          {
            number: "5",
            text: "Which famous battle is depicted in the 'Bayeux Tapestry'?",
            answers: [
              {
                letter: "A:",
                text: "Somme"
              },
              {
                letter: "B:",
                text: "Hastings"
              },
              {
                letter: "C:",
                text: "Waterloo"
              },
              {
                letter: "D:",
                text: "Agincourt"
              },
            ],
            correctAnswer: "B: Hastings",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "Not actually tapestry but an embroidery. The ‘tapestry’ is some 68m long and tells the story of the Norman Conquest of England in 1066."
          }
        ]
      }
    ],
    tiebreakerQuestion: "How many earths would fit inside the sun?",
    tiebreakerAnswer: "1.3 million"
  },
  {
    title: "Quiz Three",
    rounds: [
      {
        name: "Sport",
        questions: [
          {
            number: "1",
            text: "Queen’s Park is the oldest football club in Scotland. Their motto Ludere Causa Ludendi means?",
            answers: [
              {
                letter: "A:",
                text: "We love the beautiful game"
              },
              {
                letter: "B:",
                text: "One for all and all for one"
              },
              {
                letter: "C:",
                text: "We will play the right way"
              },
              {
                letter: "D:",
                text: "To play for the sake of playing"
              },
            ],
            correctAnswer: "D: To play for the sake of playing",
            video: require("./exercise-videos/sport-ski/sport-ski.mp4"),
            subtitles: require("./exercise-videos/sport-ski/sport-ski.vtt"),
            extraInfo: "This reflects the club’s amateur status."
          },
          {
            number: "2",
            text: "Which Premier League club has a cockerel on top of a football as its emblem?",
            answers: [
              {
                letter: "A:",
                text: "West Bromwhich Albion"
              },
              {
                letter: "B:",
                text: "Swansea City"
              },
              {
                letter: "C:",
                text: "Tottenham Hotspur"
              },
              {
                letter: "D:",
                text: "Liverpool"
              },
            ],
            correctAnswer: "C: Tottenham Hotspur",
            video: require("./exercise-videos/sport-chariots/sport-chariots.mp4"),
            subtitles: require("./exercise-videos/sport-chariots/sport-chariots.vtt"),
            extraInfo: "The club is named for medieval nobleman Harry Hotspur who enjoyed cockfighting."
          },
          {
            number: "3",
            text: "In a tennis tie-break, what is the largest winning margin?",
            answers: [
              {
                letter: "A:",
                text: "5-0"
              },
              {
                letter: "B:",
                text: "7-0"
              },
              {
                letter: "C:",
                text: "9-0"
              },
              {
                letter: "D:",
                text: "10-0"
              },
            ],
            correctAnswer: "B: 7-0",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "A simple tie-break in tennis is a race to 7 points."
          },
          {
            number: "4",
            text: "Which Olympic sport is played on a 'sheet'?",
            answers: [
              {
                letter: "A:",
                text: "Wrestling"
              },
              {
                letter: "B:",
                text: "Curling"
              },
              {
                letter: "C:",
                text: "Figure skating"
              },
              {
                letter: "D:",
                text: "Volleyball"
              },
            ],
            correctAnswer: "B: Curling",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "The playing surface is a rectangular area of ice, carefully prepared to be as flat and level as possible."
          },
          {
            number: "5",
            text: "In which country did the sport of Badminton originate?",
            answers: [
              {
                letter: "A:",
                text: "India"
              },
              {
                letter: "B:",
                text: "Scotland"
              },
              {
                letter: "C:",
                text: "France"
              },
              {
                letter: "D:",
                text: "England"
              },
            ],
            correctAnswer: "A: India",
            video: require("./exercise-videos/sport-weightlifter/sport-weightlifter.mp4"),
            subtitles: require("./exercise-videos/sport-weightlifter/sport-weightlifter.vtt"),
            extraInfo: "Developed in British India from the earlier game of battledore the sport is named after the estate of the dukes of Beaufort in England, where it was first played about 1873."
          }
        ]
      },
      {
        name: "Entertainment",
        questions: [
          {
            number: "1",
            text: "Which of these four films was NOT directed by Steven Spielberg?",
            answers: [
              {
                letter: "A:",
                text: "Titanic"
              },
              {
                letter: "B:",
                text: "Indiana Jones and The Temple of Doom"
              },
              {
                letter: "C:",
                text: "Jurassic Park"
              },
              {
                letter: "D:",
                text: "Saving Private Ryan"
              },
            ],
            correctAnswer: "A: Titanic",
            video: require("./exercise-videos/entertain-applause/entertain-applause.mp4"),
            subtitles: require("./exercise-videos/entertain-applause/entertain-applause.vtt"),
            extraInfo: "James Cameron directed Titanic."
          },
          {
            number: "2",
            text: "What is the last name of Bruce Wayne/Batman's butler Alfred?",
            answers: [
              {
                letter: "A:",
                text: "Pennywise"
              },
              {
                letter: "B:",
                text: "Penhaligon"
              },
              {
                letter: "C:",
                text: "Pennyworth"
              },
              {
                letter: "D:",
                text: "Pendragon"
              },
            ],
            correctAnswer: "C: Pennyworth",
            video: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.mp4"),
            subtitles: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.vtt"),
            extraInfo: "The character first appeared in DC Comics in 1943."
          },
          {
            number: "3",
            text: "Who headlined at the first Glastonbury Festival in 1970?",
            answers: [
              {
                letter: "A:",
                text: "The Kinks"
              },
              {
                letter: "B:",
                text: "T-Rex"
              },
              {
                letter: "C:",
                text: "David Bowie"
              },
              {
                letter: "D:",
                text: "The Who"
              },
            ],
            correctAnswer: "B: T-Rex",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "The Kinks were originally to headline but pulled out to be replaced by Marc Bolan’s T-Rex."
          },
          {
            number: "4",
            text: "The title of which Pink Floyd album is also a chapter in 'The Wind In The Willows'?",
            answers: [
              {
                letter: "A:",
                text: "The Wall"
              },
              {
                letter: "B:",
                text: "Dark Side of the Moon"
              },
              {
                letter: "C:",
                text: "A Momentary Lapse of Reason"
              },
              {
                letter: "D:",
                text: "The Piper at the Gates of Dawn"
              },
            ],
            correctAnswer: "D: The Piper at the Gates of Dawn",
            video: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4"),
            subtitles: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.vtt"),
            extraInfo: "It refers to the nature god Pan."
          },
          {
            number: "5",
            text: "Which animal can kill a lion with its kick and also attacked singer Johnny Cash?",
            answers: [
              {
                letter: "A:",
                text: "Zebra"
              },
              {
                letter: "B:",
                text: "Ostrich"
              },
              {
                letter: "C:",
                text: "Kangaroo"
              },
              {
                letter: "D:",
                text: "Gazelle"
              },
            ],
            correctAnswer: "B: Ostrich",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "The incident took place at the ‘House of Cash’ in Tennessee, which featured an enclosure for exotic animals. As a result Cash became addicted to painkillers."
          }
        ]
      },
      {
        name: "Round the world",
        questions: [
          {
            number: "1",
            text: "In Italy how would you travel on a vaporetto?",
            answers: [
              {
                letter: "A:",
                text: "By air"
              },
              {
                letter: "B:",
                text: "By land"
              },
              {
                letter: "C:",
                text: "Over water"
              },
              {
                letter: "D:",
                text: "By air, land and water"
              },
            ],
            correctAnswer: "C: Over water",
            video: require("./exercise-videos/world-thai-chi/world-thai-chi.mp4"),
            subtitles: require("./exercise-videos/world-thai-chi/world-thai-chi.vtt"),
            extraInfo: "It is a Venetian water bus."
          },
          {
            number: "2",
            text: "Which of these countries is closest to the Isle of Man?",
            answers: [
              {
                letter: "A:",
                text: "Scotland"
              },
              {
                letter: "B:",
                text: "England"
              },
              {
                letter: "C:",
                text: "Northern Ireland"
              },
              {
                letter: "D:",
                text: "Wales"
              },
            ],
            correctAnswer: "A: Scotland",
            video: require("./exercise-videos/world-everest/world-everest.mp4"),
            subtitles: require("./exercise-videos/world-everest/world-everest.vtt"),
            extraInfo: "26 miles Scotland"
          },
          {
            number: "3",
            text: "What is the capital city of Australia?",
            answers: [
              {
                letter: "A:",
                text: "Canberra"
              },
              {
                letter: "B:",
                text: "Perth"
              },
              {
                letter: "C:",
                text: "Melbourne"
              },
              {
                letter: "D:",
                text: "Sydney"
              },
            ],
            correctAnswer: "A: Canberra",
            video: require("./exercise-videos/world-everest/world-everest.mp4"),
            subtitles: require("./exercise-videos/world-everest/world-everest.vtt"),
            extraInfo: "Selected as a compromise between the warring town of Melbourne and Sydney in 1913."
          },
          {
            number: "4",
            text: "In which of the following countries would you drive on the left of the road?",
            answers: [
              {
                letter: "A:",
                text: "Estonia"
              },
              {
                letter: "B:",
                text: "Cyprus"
              },
              {
                letter: "C:",
                text: "Finland"
              },
              {
                letter: "D:",
                text: "Turkey"
              },
            ],
            correctAnswer: "B: Cyprus",
            video: require("./exercise-videos/world-barn-dance/world-barn-dance.mp4"),
            subtitles: require("./exercise-videos/world-barn-dance/world-barn-dance.vtt"),
            extraInfo: "More than 50 countries around the world drive on the left side of the road."
          },
          {
            number: "5",
            text: "What is the largest country in the world by area?",
            answers: [
              {
                letter: "A:",
                text: "China"
              },
              {
                letter: "B:",
                text: "U.S.A"
              },
              {
                letter: "C:",
                text: "Canada"
              },
              {
                letter: "D:",
                text: "Russia"
              },
            ],
            correctAnswer: "D: Russia",
            video: require("./exercise-videos/world-can-can/world-can-can.mp4"),
            subtitles: require("./exercise-videos/world-can-can/world-can-can.vtt"),
            extraInfo: "Russia 6,601,665 sq miles, Canada 3,855,101 sq miles, China 3,747,877 sq miles, U.S.A 3,618,783 sq miles."
          }
        ]
      },
      {
        name: "History",
        questions: [
          {
            number: "1",
            text: "Which of these inventions could Queen Victoria have never seen in her lifetime?",
            answers: [
              {
                letter: "A:",
                text: "Teabags"
              },
              {
                letter: "B:",
                text: "Telephone"
              },
              {
                letter: "C:",
                text: "Photograph"
              },
              {
                letter: "D:",
                text: "Coca Cola"
              },
            ],
            correctAnswer: "A: Teabags",
            video: require("./exercise-videos/history-cold-war/history-cold-war.mp4"),
            subtitles: require("./exercise-videos/history-cold-war/history-cold-war.vtt"),
            extraInfo: "Tea bag patents date from 1903. Queen Victoria died 1901."
          },
          {
            number: "2",
            text: "Who was Prime Minister when Britain joined the European Union?",
            answers: [
              {
                letter: "A:",
                text: "Harold Wilson"
              },
              {
                letter: "B:",
                text: "Jim Callaghan"
              },
              {
                letter: "C:",
                text: "Alec Douglas-Home"
              },
              {
                letter: "D:",
                text: "Edward Heath"
              },
            ],
            correctAnswer: "D: Edward Heath",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "Heath was Prime Minister from 1970-1974. He was succeeded by Harold Wilson."
          },
          {
            number: "3",
            text: "In which country was Milton Obote overthrown by Idi Amin in 1971?",
            answers: [
              {
                letter: "A:",
                text: "Sudan"
              },
              {
                letter: "B:",
                text: "Uganda"
              },
              {
                letter: "C:",
                text: "Ethiopia"
              },
              {
                letter: "D:",
                text: "Kenya"
              },
            ],
            correctAnswer: "B: Uganda",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "Amin was a military officer who ruled until 1979. Known as the \"Butcher of Uganda\", he is considered one of the cruellest despots in history."
          },
          {
            number: "4",
            text: "The 15th century book by minstrel Blind Harry romanticised whom.",
            answers: [
              {
                letter: "A:",
                text: "Macbeth"
              },
              {
                letter: "B:",
                text: "Alfred the Great"
              },
              {
                letter: "C:",
                text: "William Wallace"
              },
              {
                letter: "D:",
                text: "King Arthur"
              },
            ],
            correctAnswer: "C: William Wallace",
            video: require("./exercise-videos/history-bagpipe/history-bagpipe.mp4"),
            subtitles: require("./exercise-videos/history-bagpipe/history-bagpipe.vtt"),
            extraInfo: "Blind Harry’s book portrays Wallace as superhuman and is historically dubious."
          },
          {
            number: "5",
            text: "What was banned in Scotland from 1747 to 1782?",
            answers: [
              {
                letter: "A:",
                text: "Singing ‘Flower of Scotland’"
              },
              {
                letter: "B:",
                text: "Theatre"
              },
              {
                letter: "C:",
                text: "Caber tossing"
              },
              {
                letter: "D:",
                text: "Highland Dress"
              },
            ],
            correctAnswer: "D: Highland Dress",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "To supress rebel clans after the Jacobite rebellion."
          }
        ]
      }
    ],
    tiebreakerQuestion: "The Battle of Trafalgar, between the British Royal Navy and the combined French and Spanish fleets, took place when?",
    tiebreakerAnswer: "1805"
  },
  {
    title: "Quiz Four",
    rounds: [
      {
        name: "Sport",
        questions: [
          {
            number: "1",
            text: "Which was the last team to lift rugby’s Five Nations trophy?",
            answers: [
              {
                letter: "A:",
                text: "France"
              },
              {
                letter: "B:",
                text: "Scotland"
              },
              {
                letter: "C:",
                text: "Wales"
              },
              {
                letter: "D:",
                text: "England"
              },
            ],
            correctAnswer: "B: Scotland",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "Scotland in 1999. The following year it became the Six Nations with the addition of Italy."
          },
          {
            number: "2",
            text: "Silverstone is known as the British home of what?",
            answers: [
              {
                letter: "A:",
                text: "Cycling"
              },
              {
                letter: "B:",
                text: "Monster Trucks"
              },
              {
                letter: "C:",
                text: "Paragliding"
              },
              {
                letter: "D:",
                text: "Motor Racing"
              },
            ],
            correctAnswer: "D: Motor Racing",
            video: require("./exercise-videos/sport-ski/sport-ski.mp4"),
            subtitles: require("./exercise-videos/sport-ski/sport-ski.vtt"),
            extraInfo: "A surplus airfield by the village of Silverstone opened as a racetrack in 1948."
          },
          {
            number: "3",
            text: "Which British athlete won gold in both 5,000m and 10,000m races at two successive Olympics?",
            answers: [
              {
                letter: "A:",
                text: "Mo Farah"
              },
              {
                letter: "B:",
                text: "Sebastian Coe"
              },
              {
                letter: "C:",
                text: "Linford Christie"
              },
              {
                letter: "D:",
                text: "Colin Jackson"
              },
            ],
            correctAnswer: "A: Mo Farah",
            video: require("./exercise-videos/sport-weightlifter/sport-weightlifter.mp4"),
            subtitles: require("./exercise-videos/sport-weightlifter/sport-weightlifter.vtt"),
            extraInfo: "Farah is the second athlete in modern  Olympic history, after Lasse Virén, to achieve this."
          },
          {
            number: "4",
            text: "Which English football club's ground was a P.O.W camp in World War 2?",
            answers: [
              {
                letter: "A:",
                text: "Manchester City"
              },
              {
                letter: "B:",
                text: "Leicester City"
              },
              {
                letter: "C:",
                text: "Swindon"
              },
              {
                letter: "D:",
                text: "Wolves"
              },
            ],
            correctAnswer: "C: Swindon",
            video: require("./exercise-videos/sport-chariots/sport-chariots.mp4"),
            subtitles: require("./exercise-videos/sport-chariots/sport-chariots.vtt"),
            extraInfo: "At the end of the 1939–40 season the War Department requisitioned the ground for use as a Prisoner-of-war camp."
          },
          {
            number: "5",
            text: "Who won the FIFA Women’s World Cup in 2019?",
            answers: [
              {
                letter: "A:",
                text: "Netherlands"
              },
              {
                letter: "B:",
                text: "U.S.A"
              },
              {
                letter: "C:",
                text: "Germany"
              },
              {
                letter: "D:",
                text: "Japan"
              },
            ],
            correctAnswer: "B: U.S.A",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "Beating Netherlands 2–0 to become the first team in history to win four Women's World Cup titles."
          }
        ]
      },
      {
        name: "Entertainment",
        questions: [
          {
            number: "1",
            text: "What is the middle name of cartoon character Donald Duck?",
            answers: [
              {
                letter: "A:",
                text: "Davenport"
              },
              {
                letter: "B:",
                text: "Duckworth"
              },
              {
                letter: "C:",
                text: "Lovejoy"
              },
              {
                letter: "D:",
                text: "Fauntleroy"
              },
            ],
            correctAnswer: "D: Fauntleroy",
            video: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4"),
            subtitles: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.vtt"),
            extraInfo: "The character was created in 1934 at Walt Disney Productions."
          },
          {
            number: "2",
            text: "In 1999 who was named greatest female star of Classic Hollywood Cinema?",
            answers: [
              {
                letter: "A:",
                text: "Katharine Hepburn"
              },
              {
                letter: "B:",
                text: "Audrey Hepburn"
              },
              {
                letter: "C:",
                text: "Ginger Rogers"
              },
              {
                letter: "D:",
                text: "Marlene Dietrich"
              },
            ],
            correctAnswer: "A: Katharine Hepburn",
            video: require("./exercise-videos/entertain-applause/entertain-applause.mp4"),
            subtitles: require("./exercise-videos/entertain-applause/entertain-applause.vtt"),
            extraInfo: "Awarded by the American Film Institute. Hepburn (1907-2003) received four Leading Actor Academy Awards (Oscars)."
          },
          {
            number: "3",
            text: "Which Richard did Elizabeth Taylor marry twice?",
            answers: [
              {
                letter: "A:",
                text: "Harris"
              },
              {
                letter: "B:",
                text: "Burton"
              },
              {
                letter: "C:",
                text: "Gere"
              },
              {
                letter: "D:",
                text: "Nixon"
              },
            ],
            correctAnswer: "B: Burton",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "The couple also divorced twice. They made 11 movies together."
          },
          {
            number: "4",
            text: "Who was originally known as The Naked Chef?",
            answers: [
              {
                letter: "A:",
                text: "Gordon Ramsay"
              },
              {
                letter: "B:",
                text: "Jamie Oliver"
              },
              {
                letter: "C:",
                text: "Heston Blumenthal"
              },
              {
                letter: "D:",
                text: "Nigella Lawson"
              },
            ],
            correctAnswer: "B: Jamie Oliver",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "The Naked Chef ran on BBC for 3 seasons between 1999 and 2001 and was Oliver’s debut."
          },
          {
            number: "5",
            text: "James Bond's favourite drink is what?",
            answers: [
              {
                letter: "A:",
                text: "Bloody Mary"
              },
              {
                letter: "B:",
                text: "Vodka Martini (Stirred, not shaken)"
              },
              {
                letter: "C:",
                text: "Vodka Martini (Shaken, not stirred)"
              },
              {
                letter: "D:",
                text: "Dirty Martini"
              },
            ],
            correctAnswer: "C: Vodka Martini (Shaken, not stirred)",
            video: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.mp4"),
            subtitles: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.vtt"),
            extraInfo: ""
          }
        ]
      },
      {
        name: "Round the world",
        questions: [
          {
            number: "1",
            text: "With 2,300 within its limits which city has the most bridges in the world?",
            answers: [
              {
                letter: "A:",
                text: "Amsterdam"
              },
              {
                letter: "B:",
                text: "Pittsburgh"
              },
              {
                letter: "C:",
                text: "Hamburg"
              },
              {
                letter: "D:",
                text: "New York"
              },
            ],
            correctAnswer: "C: Hamburg",
            video: require("./exercise-videos/world-thai-chi/world-thai-chi.mp4"),
            subtitles: require("./exercise-videos/world-thai-chi/world-thai-chi.vtt"),
            extraInfo: "Hamburg—2,300, Amsterdam—1,281, New York—789, New York—446"
          },
          {
            number: "2",
            text: "Udon and Ho Fun are examples of which of the following?",
            answers: [
              {
                letter: "A:",
                text: "Tofu"
              },
              {
                letter: "B:",
                text: "Noodles"
              },
              {
                letter: "C:",
                text: "Sushi"
              },
              {
                letter: "D:",
                text: "Soup"
              },
            ],
            correctAnswer: "B: Noodles",
            video: require("./exercise-videos/world-barn-dance/world-barn-dance.mp4"),
            subtitles: require("./exercise-videos/world-barn-dance/world-barn-dance.vtt"),
            extraInfo: "Ho Fun are wide fat rice noodles popular in south China. Udon is a thick wheat flower noodle from Japan."
          },
          {
            number: "3",
            text: "The Gallipoli peninsula is found in which country?",
            answers: [
              {
                letter: "A:",
                text: "Syria"
              },
              {
                letter: "B:",
                text: "Armenia"
              },
              {
                letter: "C:",
                text: "Greece"
              },
              {
                letter: "D:",
                text: "Turkey"
              },
            ],
            correctAnswer: "D: Turkey",
            video: require("./exercise-videos/world-can-can/world-can-can.mp4"),
            subtitles: require("./exercise-videos/world-can-can/world-can-can.vtt"),
            extraInfo: "Gallipoli is in the European part of Turkey, with the Aegean Sea to the west and the Dardanelles strait to the east."
          },
          {
            number: "4",
            text: "How many smaller stars are around the bigger star on the flag of China?",
            answers: [
              {
                letter: "A:",
                text: "Four"
              },
              {
                letter: "B:",
                text: "Five"
              },
              {
                letter: "C:",
                text: "Six"
              },
              {
                letter: "D:",
                text: "Seven"
              },
            ],
            correctAnswer: "A: Four",
            video: require("./exercise-videos/world-everest/world-everest.mp4"),
            subtitles: require("./exercise-videos/world-everest/world-everest.vtt"),
            extraInfo: "The red background represents the Communist Revolution and the five stars the unity of the people under Communist Party leadership."
          },
          {
            number: "5",
            text: "What should you expect to happen if you go swimming in the Dead Sea?",
            answers: [
              {
                letter: "A:",
                text: "You die"
              },
              {
                letter: "B:",
                text: "You float"
              },
              {
                letter: "C:",
                text: "You sink"
              },
              {
                letter: "D:",
                text: "You gain vitality"
              },
            ],
            correctAnswer: "B: You float",
            video: require("./exercise-videos/world-barn-dance/world-barn-dance.mp4"),
            subtitles: require("./exercise-videos/world-barn-dance/world-barn-dance.vtt"),
            extraInfo: "The ’sea’ is a saltwater lack between Israel and Jordan. The salt content of the water is so high bathers float on the surface of the water."
          }
        ]
      },
      {
        name: "History",
        questions: [
          {
            number: "1",
            text: "Florence Nightingale's most famous contribution came during which war?",
            answers: [
              {
                letter: "A:",
                text: "The Crimean"
              },
              {
                letter: "B:",
                text: "Afghan War"
              },
              {
                letter: "C:",
                text: "Boer War"
              },
              {
                letter: "D:",
                text: "Indian Mutiny"
              },
            ],
            correctAnswer: "A: The Crimean",
            video: require("./exercise-videos/history-cold-war/history-cold-war.mp4"),
            subtitles: require("./exercise-videos/history-cold-war/history-cold-war.vtt"),
            extraInfo: "Nightingale, founder of modern nursing, was in charge of nursing British and allied soldiers in Turkey during the Crimean War (1853–1856)."
          },
          {
            number: "2",
            text: "In which city in 1916 did the Easter Rising take place?",
            answers: [
              {
                letter: "A:",
                text: "Belfast"
              },
              {
                letter: "B:",
                text: "Dublin"
              },
              {
                letter: "C:",
                text: "Paris"
              },
              {
                letter: "D:",
                text: "Rome"
              },
            ],
            correctAnswer: "B: Dublin",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "On Easter Monday 2016 opponents of British rule in Ireland seized key buildings in Dublin and clashed with troops."
          },
          {
            number: "3",
            text: "Who was the last of the Tudor monarchs?",
            answers: [
              {
                letter: "A:",
                text: "Henry VIII"
              },
              {
                letter: "B:",
                text: "Richard III"
              },
              {
                letter: "C:",
                text: "James I"
              },
              {
                letter: "D:",
                text: "Elizabeth I"
              },
            ],
            correctAnswer: "D: Elizabeth I",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "Elizabeth I, ‘The Virgin Queen’ died child-less in 1603, ending 118 years of Tudor rule."
          },
          {
            number: "4",
            text: "Which of the following was NOT married to Mary Queen of Scots.",
            answers: [
              {
                letter: "A:",
                text: "Lord Darnley"
              },
              {
                letter: "B:",
                text: "David Rizzio"
              },
              {
                letter: "C:",
                text: "The Earl of Boswell"
              },
              {
                letter: "D:",
                text: "Francis II of France"
              },
            ],
            correctAnswer: "B: David Rizzio",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "Rizzo, Mary’s private secretary, was murdered by a gang led by Lord Darnley in 1566."
          },
          {
            number: "5",
            text: "In Roman Britain which tribe did rebel Queen Boudicca belong to?",
            answers: [
              {
                letter: "A:",
                text: "Demetae"
              },
              {
                letter: "B:",
                text: "Brigantes"
              },
              {
                letter: "C:",
                text: "Damnonii"
              },
              {
                letter: "D:",
                text: "Iceni"
              },
            ],
            correctAnswer: "D: Iceni",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "On the death of her husband the Romans annexed Iceni lands, triggering a bloody revolt by the Queen which was ultimately defeated."
          }
        ]
      }
    ],
    tiebreakerQuestion: "In which year was the last National Serviceman in Britain demobbed?",
    tiebreakerAnswer: "1963"
  },
  {
    title: "My Quiz",
    rounds: [
      {
        name: "Sport",
        questions: [
          {
            number: "1",
            text: "Which was the last team to lift rugby’s Five Nations trophy?",
            answers: [
              {
                letter: "A:",
                text: "France"
              },
              {
                letter: "B:",
                text: "Scotland"
              },
              {
                letter: "C:",
                text: "Wales"
              },
              {
                letter: "D:",
                text: "England"
              },
            ],
            correctAnswer: "B: Scotland",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "Scotland in 1999. The following year it became the Six Nations with the addition of Italy."
          },
          {
            number: "2",
            text: "Silverstone is known as the British home of what?",
            answers: [
              {
                letter: "A:",
                text: "Cycling"
              },
              {
                letter: "B:",
                text: "Monster Trucks"
              },
              {
                letter: "C:",
                text: "Paragliding"
              },
              {
                letter: "D:",
                text: "Motor Racing"
              },
            ],
            correctAnswer: "D: Motor Racing",
            video: require("./exercise-videos/sport-ski/sport-ski.mp4"),
            subtitles: require("./exercise-videos/sport-ski/sport-ski.vtt"),
            extraInfo: "A surplus airfield by the village of Silverstone opened as a racetrack in 1948."
          },
          {
            number: "3",
            text: "Which British athlete won gold in both 5,000m and 10,000m races at two successive Olympics?",
            answers: [
              {
                letter: "A:",
                text: "Mo Farah"
              },
              {
                letter: "B:",
                text: "Sebastian Coe"
              },
              {
                letter: "C:",
                text: "Linford Christie"
              },
              {
                letter: "D:",
                text: "Colin Jackson"
              },
            ],
            correctAnswer: "A: Mo Farah",
            video: require("./exercise-videos/sport-weightlifter/sport-weightlifter.mp4"),
            subtitles: require("./exercise-videos/sport-weightlifter/sport-weightlifter.vtt"),
            extraInfo: "Farah is the second athlete in modern  Olympic history, after Lasse Virén, to achieve this."
          },
          {
            number: "4",
            text: "Which English football club's ground was a P.O.W camp in World War 2?",
            answers: [
              {
                letter: "A:",
                text: "Manchester City"
              },
              {
                letter: "B:",
                text: "Leicester City"
              },
              {
                letter: "C:",
                text: "Swindon"
              },
              {
                letter: "D:",
                text: "Wolves"
              },
            ],
            correctAnswer: "C: Swindon",
            video: require("./exercise-videos/sport-chariots/sport-chariots.mp4"),
            subtitles: require("./exercise-videos/sport-chariots/sport-chariots.vtt"),
            extraInfo: "At the end of the 1939–40 season the War Department requisitioned the ground for use as a Prisoner-of-war camp."
          },
          {
            number: "5",
            text: "Who won the FIFA Women’s World Cup in 2019?",
            answers: [
              {
                letter: "A:",
                text: "Netherlands"
              },
              {
                letter: "B:",
                text: "U.S.A"
              },
              {
                letter: "C:",
                text: "Germany"
              },
              {
                letter: "D:",
                text: "Japan"
              },
            ],
            correctAnswer: "B: U.S.A",
            video: require("./exercise-videos/sport-boxing/sport-boxing.mp4"),
            subtitles: require("./exercise-videos/sport-boxing/sport-boxing.vtt"),
            extraInfo: "Beating Netherlands 2–0 to become the first team in history to win four Women's World Cup titles."
          }
        ]
      },
      {
        name: "Entertainment",
        questions: [
          {
            number: "1",
            text: "What is the middle name of cartoon character Donald Duck?",
            answers: [
              {
                letter: "A:",
                text: "Davenport"
              },
              {
                letter: "B:",
                text: "Duckworth"
              },
              {
                letter: "C:",
                text: "Lovejoy"
              },
              {
                letter: "D:",
                text: "Fauntleroy"
              },
            ],
            correctAnswer: "D: Fauntleroy",
            video: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4"),
            subtitles: require("./exercise-videos/entertain-easy-rider/entertain-easy-rider.vtt"),
            extraInfo: "The character was created in 1934 at Walt Disney Productions."
          },
          {
            number: "2",
            text: "In 1999 who was named greatest female star of Classic Hollywood Cinema?",
            answers: [
              {
                letter: "A:",
                text: "Katharine Hepburn"
              },
              {
                letter: "B:",
                text: "Audrey Hepburn"
              },
              {
                letter: "C:",
                text: "Ginger Rogers"
              },
              {
                letter: "D:",
                text: "Marlene Dietrich"
              },
            ],
            correctAnswer: "A: Katharine Hepburn",
            video: require("./exercise-videos/entertain-applause/entertain-applause.mp4"),
            subtitles: require("./exercise-videos/entertain-applause/entertain-applause.vtt"),
            extraInfo: "Awarded by the American Film Institute. Hepburn (1907-2003) received four Leading Actor Academy Awards (Oscars)."
          },
          {
            number: "3",
            text: "Which Richard did Elizabeth Taylor marry twice?",
            answers: [
              {
                letter: "A:",
                text: "Harris"
              },
              {
                letter: "B:",
                text: "Burton"
              },
              {
                letter: "C:",
                text: "Gere"
              },
              {
                letter: "D:",
                text: "Nixon"
              },
            ],
            correctAnswer: "B: Burton",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "The couple also divorced twice. They made 11 movies together."
          },
          {
            number: "4",
            text: "Who was originally known as The Naked Chef?",
            answers: [
              {
                letter: "A:",
                text: "Gordon Ramsay"
              },
              {
                letter: "B:",
                text: "Jamie Oliver"
              },
              {
                letter: "C:",
                text: "Heston Blumenthal"
              },
              {
                letter: "D:",
                text: "Nigella Lawson"
              },
            ],
            correctAnswer: "B: Jamie Oliver",
            video: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"),
            subtitles: require("./exercise-videos/entertain-kung-fu/entertain-kung-fu.vtt"),
            extraInfo: "The Naked Chef ran on BBC for 3 seasons between 1999 and 2001 and was Oliver’s debut."
          },
          {
            number: "5",
            text: "James Bond's favourite drink is what?",
            answers: [
              {
                letter: "A:",
                text: "Bloody Mary"
              },
              {
                letter: "B:",
                text: "Vodka Martini (Stirred, not shaken)"
              },
              {
                letter: "C:",
                text: "Vodka Martini (Shaken, not stirred)"
              },
              {
                letter: "D:",
                text: "Dirty Martini"
              },
            ],
            correctAnswer: "C: Vodka Martini (Shaken, not stirred)",
            video: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.mp4"),
            subtitles: require("./exercise-videos/entertain-brylcreem/entertain-brylcreem.vtt"),
            extraInfo: ""
          }
        ]
      },
      {
        name: "Round the world",
        questions: [
          {
            number: "1",
            text: "With 2,300 within its limits which city has the most bridges in the world?",
            answers: [
              {
                letter: "A:",
                text: "Amsterdam"
              },
              {
                letter: "B:",
                text: "Pittsburgh"
              },
              {
                letter: "C:",
                text: "Hamburg"
              },
              {
                letter: "D:",
                text: "New York"
              },
            ],
            correctAnswer: "C: Hamburg",
            video: require("./exercise-videos/world-thai-chi/world-thai-chi.mp4"),
            subtitles: require("./exercise-videos/world-thai-chi/world-thai-chi.vtt"),
            extraInfo: "Hamburg—2,300, Amsterdam—1,281, New York—789, New York—446"
          },
          {
            number: "2",
            text: "Udon and Ho Fun are examples of which of the following?",
            answers: [
              {
                letter: "A:",
                text: "Tofu"
              },
              {
                letter: "B:",
                text: "Noodles"
              },
              {
                letter: "C:",
                text: "Sushi"
              },
              {
                letter: "D:",
                text: "Soup"
              },
            ],
            correctAnswer: "B: Noodles",
            video: require("./exercise-videos/world-barn-dance/world-barn-dance.mp4"),
            subtitles: require("./exercise-videos/world-barn-dance/world-barn-dance.vtt"),
            extraInfo: "Ho Fun are wide fat rice noodles popular in south China. Udon is a thick wheat flower noodle from Japan."
          },
          {
            number: "3",
            text: "The Gallipoli peninsula is found in which country?",
            answers: [
              {
                letter: "A:",
                text: "Syria"
              },
              {
                letter: "B:",
                text: "Armenia"
              },
              {
                letter: "C:",
                text: "Greece"
              },
              {
                letter: "D:",
                text: "Turkey"
              },
            ],
            correctAnswer: "D: Turkey",
            video: require("./exercise-videos/world-can-can/world-can-can.mp4"),
            subtitles: require("./exercise-videos/world-can-can/world-can-can.vtt"),
            extraInfo: "Gallipoli is in the European part of Turkey, with the Aegean Sea to the west and the Dardanelles strait to the east."
          },
          {
            number: "4",
            text: "How many smaller stars are around the bigger star on the flag of China?",
            answers: [
              {
                letter: "A:",
                text: "Four"
              },
              {
                letter: "B:",
                text: "Five"
              },
              {
                letter: "C:",
                text: "Six"
              },
              {
                letter: "D:",
                text: "Seven"
              },
            ],
            correctAnswer: "A: Four",
            video: require("./exercise-videos/world-everest/world-everest.mp4"),
            subtitles: require("./exercise-videos/world-everest/world-everest.vtt"),
            extraInfo: "The red background represents the Communist Revolution and the five stars the unity of the people under Communist Party leadership."
          },
          {
            number: "5",
            text: "What should you expect to happen if you go swimming in the Dead Sea?",
            answers: [
              {
                letter: "A:",
                text: "You die"
              },
              {
                letter: "B:",
                text: "You float"
              },
              {
                letter: "C:",
                text: "You sink"
              },
              {
                letter: "D:",
                text: "You gain vitality"
              },
            ],
            correctAnswer: "B: You float",
            video: require("./exercise-videos/world-barn-dance/world-barn-dance.mp4"),
            subtitles: require("./exercise-videos/world-barn-dance/world-barn-dance.vtt"),
            extraInfo: "The ’sea’ is a saltwater lack between Israel and Jordan. The salt content of the water is so high bathers float on the surface of the water."
          }
        ]
      },
      {
        name: "History",
        questions: [
          {
            number: "1",
            text: "Florence Nightingale's most famous contribution came during which war?",
            answers: [
              {
                letter: "A:",
                text: "The Crimean"
              },
              {
                letter: "B:",
                text: "Afghan War"
              },
              {
                letter: "C:",
                text: "Boer War"
              },
              {
                letter: "D:",
                text: "Indian Mutiny"
              },
            ],
            correctAnswer: "A: The Crimean",
            video: require("./exercise-videos/history-cold-war/history-cold-war.mp4"),
            subtitles: require("./exercise-videos/history-cold-war/history-cold-war.vtt"),
            extraInfo: "Nightingale, founder of modern nursing, was in charge of nursing British and allied soldiers in Turkey during the Crimean War (1853–1856)."
          },
          {
            number: "2",
            text: "In which city in 1916 did the Easter Rising take place?",
            answers: [
              {
                letter: "A:",
                text: "Belfast"
              },
              {
                letter: "B:",
                text: "Dublin"
              },
              {
                letter: "C:",
                text: "Paris"
              },
              {
                letter: "D:",
                text: "Rome"
              },
            ],
            correctAnswer: "B: Dublin",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "On Easter Monday 2016 opponents of British rule in Ireland seized key buildings in Dublin and clashed with troops."
          },
          {
            number: "3",
            text: "Who was the last of the Tudor monarchs?",
            answers: [
              {
                letter: "A:",
                text: "Henry VIII"
              },
              {
                letter: "B:",
                text: "Richard III"
              },
              {
                letter: "C:",
                text: "James I"
              },
              {
                letter: "D:",
                text: "Elizabeth I"
              },
            ],
            correctAnswer: "D: Elizabeth I",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "Elizabeth I, ‘The Virgin Queen’ died child-less in 1603, ending 118 years of Tudor rule."
          },
          {
            number: "4",
            text: "Which of the following was NOT married to Mary Queen of Scots.",
            answers: [
              {
                letter: "A:",
                text: "Lord Darnley"
              },
              {
                letter: "B:",
                text: "David Rizzio"
              },
              {
                letter: "C:",
                text: "The Earl of Boswell"
              },
              {
                letter: "D:",
                text: "Francis II of France"
              },
            ],
            correctAnswer: "B: David Rizzio",
            video: require("./exercise-videos/history-buddha/history-buddha.mp4"),
            subtitles: require("./exercise-videos/history-buddha/history-buddha.vtt"),
            extraInfo: "Rizzo, Mary’s private secretary, was murdered by a gang led by Lord Darnley in 1566."
          },
          {
            number: "5",
            text: "In Roman Britain which tribe did rebel Queen Boudicca belong to?",
            answers: [
              {
                letter: "A:",
                text: "Demetae"
              },
              {
                letter: "B:",
                text: "Brigantes"
              },
              {
                letter: "C:",
                text: "Damnonii"
              },
              {
                letter: "D:",
                text: "Iceni"
              },
            ],
            correctAnswer: "D: Iceni",
            video: require("./exercise-videos/history-drake/history-drake.mp4"),
            subtitles: require("./exercise-videos/history-drake/history-drake.vtt"),
            extraInfo: "On the death of her husband the Romans annexed Iceni lands, triggering a bloody revolt by the Queen which was ultimately defeated."
          }
        ]
      }
    ],
    tiebreakerQuestion: "In which year was the last National Serviceman in Britain demobbed?",
    tiebreakerAnswer: "1963"
  }
];

export default data;
